export default __webpack_public_path__ + "static/media/NIAS0220.34I-29135_-16931_0.b1ed1052.jpg";